export const pendingBookings = {
  configTitle: "Direktbuchungen einrichten",
  configText:
    "Aktivieren Sie Direktbuchungen, um ausstehende Zahlungen und Buchungsanfragen Ihrer Gäste direkt hier zu verwalten.",
  reminderLabel: "Erinnerung:",
  reminderReasonIntent: "Zahlung ausstehend von",
  reminderReasonUnassigned: "Zimmer zuweisen für",
  reminderReasonRequest: "Anfrage zu prüfen von",
  combined: "Kombiniert · {count} Zimmer",
  expired: "Abgelaufen",
  toastSuccessTitle: "Erfolg",
  toastErrorTitle: "Fehler",
  toastWarningTitle: "Warnung",
};
